export const fields = {
  computed: {
    fields() {
      return [
        {
          key: 'columnCheckModal',
          thClass: 'mc-table--30',
          sortable: false,
        },
        {
          key: 'licensePlate',
          label: this.$t('global.object.licensePlate'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'manufacturer',
          label: this.$t('global.object.manufacture'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'category',
          label: this.$t('global.object.fleetCategory'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'vehicleType',
          label: this.$t('global.field.vehicleType'),
          thClass: 'mc-table--50',
          sortable: true,
        },
      ]
    },
  }
}